// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y2Vn","questions":"styles_questions__1TpJN","footer":"styles_footer__23WXY"};